/**
 * 主布局组件
 */
import { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, theme } from 'antd';
import {
  DashboardOutlined,
  LineChartOutlined,
  GlobalOutlined,
  ThunderboltOutlined,
  BarChartOutlined,
  SwapOutlined,
  MonitorOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';

const { Header, Content, Footer, Sider } = Layout;

type MenuItem = Required<MenuProps>['items'][number];

const menuItems: MenuItem[] = [
  {
    key: '/',
    icon: <DashboardOutlined />,
    label: '平台首页',
  },
  {
    key: '/prices',
    icon: <LineChartOutlined />,
    label: '价格趋势',
  },
  {
    key: '/industry-chain',
    icon: <GlobalOutlined />,
    label: '产业链地图',
  },
  {
    key: '/storage',
    icon: <ThunderboltOutlined />,
    label: '储能项目',
  },
  {
    key: '/supply-demand',
    icon: <BarChartOutlined />,
    label: '供需分析',
  },
  {
    key: '/trade',
    icon: <SwapOutlined />,
    label: '贸易路径',
  },

];

export default function MainLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    navigate(e.key);
  };

  return (
    <Layout style={{ minHeight: '100vh', background: 'var(--bg-layout)' }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        theme="light"
        width={220}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          borderRight: '1px solid rgba(255, 255, 255, 0.2)',
          zIndex: 100,
        }}
        trigger={null}
      >
        <div
          style={{
            height: 64,
            margin: '0 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontWeight: 'bold',
            fontSize: '16px',
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          }}
        >
          {!collapsed && '钒荣网产业地图'}
        </div>
        <Menu
          theme="dark"
          selectedKeys={[location.pathname]}
          mode="inline"
          items={menuItems}
          onClick={handleMenuClick}
          style={{
            background: 'transparent',
            borderRight: 'none',
            color: 'white',
          }}
        // Note: AntD Menu "dark" theme might force background. 
        // We might need to override styles in global css if this doesn't work perfectly.
        />
      </Sider>

      <Layout
        style={{
          marginLeft: collapsed ? 80 : 220,
          transition: 'all 0.2s',
          background: 'transparent'
        }}
      >
        <Header
          style={{
            padding: '0 24px',
            background: 'rgba(0, 0, 0, 0.1)',
            backdropFilter: 'blur(5px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            // boxShadow: '0 1px 4px rgba(0,0,0,.15)',
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
            height: 64,
            color: '#fff'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {/* Toggle button could go here */}
            <h1 style={{ margin: 0, fontSize: '20px', fontWeight: 500, color: '#fff' }}>
              钒荣网产业地图平台
            </h1>
          </div>
        </Header>

        <Content style={{ margin: '24px 24px 0', overflow: 'initial' }}>
          {/* Removed the solid white container to allow page-specific card layouts */}
          <div style={{ minHeight: 360 }}>
            <Outlet />
          </div>
        </Content>

        <Footer style={{ textAlign: 'center', background: 'transparent', color: 'rgba(255,255,255,0.6)' }}>
          钒荣网产业地图平台 ©{new Date().getFullYear()}
        </Footer>
      </Layout>
    </Layout>
  );
}
